import { withInstall } from '@vuesax-alpha/utils'
import Radio from './src/radio.vue'

export const VsRadio = withInstall(Radio)
export default VsRadio

export * from './src/radio'
